import React from "react";
import styled from "styled-components";

const cities = [
  {
    name: "New York, NY",
    image:
      "https://www.redfin.com/blog/wp-content/uploads/2023/12/New-York-City.jpg",
  },
  {
    name: "San Francisco, CA",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/6/61/San_Francisco_from_the_Marin_Headlands_in_August_2022.jpg",
  },
  {
    name: "Atlanta, GA",
    image:
      "https://cdn.britannica.com/16/216816-050-9D07E395/atlanta-skyline-georgia.jpg",
  },
  {
    name: "Chicago, IL",
    image:
      "https://e7jecw7o93n.exactdn.com/wp-content/uploads/2023/05/iStock-Chicago-IL-511665488.jpg",
  },
  {
    name: "Toronto, ON",
    image:
      "https://cdn-adventures-live.azureedge.net/adventurescache/4/e/8/1/8/3/4e81834dcf22a643482592a037487a2ee2fd301f.jpg",
  },
  {
    name: "Vancouver, BC",
    image:
      "https://www.vmcdn.ca/f/files/via/images/tourism/aerial-view-vancouver-coast-septemeber-2021.jpg",
  },
  {
    name: "Los Angeles, CA",
    image:
      "https://e7jecw7o93n.exactdn.com/wp-content/uploads/2019/05/LosAngelesCA.jpg",
  },
  {
    name: "Dallas, TX",
    image:
      "https://www.redfin.com/blog/wp-content/uploads/2024/06/dallas-skyline.jpg",
  },
  {
    name: "Ottawa, ON",
    image:
      "https://www.tripsavvy.com/thmb/jzkYky-CqNO2LP1AEeBE1r6-mxs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/parliament-hill-in-fall--ottawa--ontario--canada-1064713266-b595c67f48ca4778a985b13bb598ba04.jpg",
  },
  {
    name: "Montreal, QC",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Mtl_from_mont_royal_%28cropped%29.jpg/1200px-Mtl_from_mont_royal_%28cropped%29.jpg",
  },
  {
    name: "Austin, TX",
    image:
      "https://drifttravel.com/wp-content/uploads/2024/07/austin-texas-usa-downtown-skyline-over-the-color-2023-11-27-04-49-56-utc-copy-640x411.webp",
  },
  {
    name: "Boston, MA",
    image:
      "https://www.travelandleisure.com/thmb/_aMbik8KZYsUKc_6_XNeAOzPi84=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/boston-massachusetts-BOSTONTG0221-719aef2eeb1c4929b6c839715e34a69e.jpg",
  },
  {
    name: "Miami, FL",
    image:
      "https://i.natgeofe.com/n/5de6e34a-d550-4358-b7ef-4d79a09c680e/aerial-beach-miami-florida_16x9.jpg",
  },
  {
    name: "Phoenix, AZ",
    image:
      "https://www.tripsavvy.com/thmb/TCqed-dWhz986MsI1ZQaV8WFRaA=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Phoenix-Arizona-Test-Shoot-9WEB-5c4751e8c9e77c00017460c2.jpg",
  },
  {
    name: "Houston, TX",
    image:
      "https://www.tshaonline.org/images/handbook/entries/HH/houston_tx.jpg",
  },
];

const Wrapper = styled.div`
  padding: 40px 0;
`;

const Title = styled.h2`
  font-size: 22px;
  margin-bottom: 8px;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
`;

const Card = styled.div`
  aspect-ratio: 1 / 1;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-4px);
  }

  img {
    width: 100%;
    height: auto;
    flex: 1;
    object-fit: cover;
    border-radius: 10px;
  }

  p {
    padding-top: 10px;
    font-size: 14px;
    text-align: left;
  }
`;

const PopularCities = () => {
  return (
    <Wrapper>
      <Title>Popular cities</Title>
      <Subtitle>
        Discover houses and apartments for rent in our most popular locations.
      </Subtitle>
      <Grid>
        {cities.map((city, index) => (
          <Card key={index}>
            <img src={city.image} alt={city.name} />
            <p>{city.name}</p>
          </Card>
        ))}
      </Grid>
    </Wrapper>
  );
};

export default PopularCities;
